import { createUseStyles, Styles } from '@pff-consumer/tweed-ui/web-styles'

interface CreditCardPaymentStyles {
  container: Styles
  mandatoryIndicator: Styles
  fieldsContainer: Styles
  button: Styles
  dropdowns: Styles
}

interface CreditCardPaymentStylesProps {
  isFormOpen: boolean
}

const CONTAINER_MAX_WIDTH = 406

export const useStyles = createUseStyles<CreditCardPaymentStyles, CreditCardPaymentStylesProps>((theme) => {
  return {
    container: ({ isFormOpen }) => ({
      height: isFormOpen ? 'auto' : 0,
      opacity: isFormOpen ? theme.opacity.opaque : theme.opacity.transparent,
      overflow: isFormOpen ? 'initial' : 'hidden',
      transition: isFormOpen ? 'opacity 0.3s ease-in' : 'opacity 0.3s ease-out',
      maxWidth: theme.calcUnit(CONTAINER_MAX_WIDTH),
      marginTop: theme.calcUnit(theme.spacing.s4),
    }),
    fieldsContainer: {
      display: 'grid',
      gridColumnGap: theme.calcUnit(theme.spacing.s3),
      width: '100%',
      // This is ugly but safari was acting weird with '1fr 1fr' or '50% 50%' and we had to account for the gap I guess.
      gridTemplateColumns: `calc(50% - ${theme.calcUnit(theme.spacing.s3 / 2)}) calc(50% - ${theme.calcUnit(
        theme.spacing.s3 / 2
      )})`,
    },
    mandatoryIndicator: {
      color: theme.colors.webErrorColor,
      marginLeft: theme.calcUnit(theme.spacing.s1),
    },
    button: {
      marginTop: theme.calcUnit(theme.spacing.s3),
    },
    dropdowns: {
      marginTop: theme.calcUnit(0),
      marginBottom: theme.calcUnit(theme.spacing.s1),
    },
    // Recurly style overrides
    // The Credit Card Fields are provided by recurly and we need to use
    // their classes to style the input to look like the rest of our inputs.
    '@global': {
      '.recurly-element, .recurly-hosted-field': {
        // This will be dynamically applied through the class
        borderWidth: theme.calcUnit(1),
        borderRadius: theme.calcUnit(theme.borderRadius.roundedDefault),
        borderColor: theme.colors.inputBorderColor,
        height: '2.5rem',
        marginBottom: theme.calcUnit(theme.spacing.s1),
        marginTop: theme.calcUnit(0),
      },
      '.recurly-element-focus, .recurly-hosted-field-focus': {
        borderColor: theme.colors.inputActiveBorderColor,
      },
      '.recurly-element-invalid:not(.recurly-element-focus)': {
        borderColor: theme.colors.inputErrorBorderColor,
      },
      '.recurly-hosted-field-invalid:not(.recurly-hosted-field-focus)': {
        borderColor: theme.colors.inputErrorBorderColor,
      },
    },
  }
})
